import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule, LazyImport } from "owa-bundling-light";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OutlookServiceOptions" */ "./lazyIndex"), { name: "OutlookServiceOptions" });

export const lazyCreateOrUpdateOptionsForFeature: LazyAction<typeof lazyIndex.createOrUpdateOptionsForFeature, typeof lazyModule> = new LazyAction(lazyModule, m => m.createOrUpdateOptionsForFeature);

export const lazyUpdateAddinPinStatus: LazyAction<typeof lazyIndex.updateAddinPinStatus, typeof lazyModule> = new LazyAction(lazyModule, m => m.updateAddinPinStatus);

// Synchronous exports
export { default as getDefaultOptions } from "./data/defaultOptions";

export const lazyGetServerOptionsForFeature: LazyImport<typeof lazyIndex.getServerOptionsForFeature, typeof lazyModule> = new LazyImport(lazyModule, m => m.getServerOptionsForFeature);

// Load the options after bootstrap
// We may, in the future, move this to bootstrap and block boot on its resolution
//
// 'loadOptions' will be called by the following
// 'runAfterInitialRender'. It returns a promise, so if any consumer wants
// to act after this is completed, it can wait on its completion and do work
export const lazyLoadOptions: LazyAction<typeof lazyIndex.loadOptions, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadOptions);

export { isOptionsLoaded } from "./selectors/isOptionsLoaded";
export { isOptionsLoadedForAccount } from "./selectors/isOptionsLoadedForAccount";
export type { default as AddinPinModes } from "./utils/AddinPinModes";
export { outlookOptionsUpdated, type OutlookOptionsUpdatedActionMessage, } from "./actions/outlookOptionsUpdated";
